<template>
  <div style="height: 100%; width: 100%">
    <div
      class="word-break align-center-div"
      style="text-align: center; padding: 15px"
      v-if="!loading && warnPopupsNotAllowed"
    >
      <BaseIcon
        class="icon-header align-center"
        style="top: 0px"
        width="40"
        height="40"
        nameIcon="not-allowed"
        pathIcon="icons-ganeral"
      />
      <h3>{{ $t("bookPrint.popupWarnTitle") }}</h3>
      <p>{{ $t("bookPrint.popupWarnTxt1") }}</p>
      <p>{{ $t("bookPrint.popupWarnTxt2") }}</p>
      <baseButton class="center btn" @click="warnPopupsNotAllowed = false"
        >הבנתי</baseButton
      >
    </div>
    <div v-else :class="{ loading: loading }" class="main-container-print">
      <div class="content-print content rtl" v-if="!loading">
        <div class="font-13 bold text-color mrg-t-12">
          {{ errorMessage }}
        </div>
        <div
          style="text-align: center"
          class="font-13 bold text-color mrg-b-12"
        >
          {{ infoMessage }}
        </div>
        <div class="title mrg-b-9">{{ $t("bookPrint.printRang") }}</div>
        <div class="flex-row line-print">
          <baseCheckBox
            class="check-item check-larg"
            @change="choosePrintOnlyCurrent"
            size="larg"
            :checked="onlyCurrent"
          />
          <span>{{ $t("bookPrint.currentPage") }}</span>
        </div>
        <div class="flex-row line-print">
          <!-- <baseRadioButton class size="larg" name="print-win" @change="choosePrintRange" /> -->
          <baseCheckBox
            class="check-item check-larg"
            @change="choosePrintRange"
            size="larg"
            :checked="!onlyCurrent"
          />
          <span>{{ $t("bookPrint.from") }}</span>
          <input
            ref="from"
            type="text"
            v-model="fromPage"
            @focus="setPrintRange"
            class="a-center"
            @input="checkPages"
          />
          <span>{{ $t("bookPrint.to") }}</span>
          <input
            ref="true"
            type="text"
            class="a-center"
            v-model="toPage"
            @focus="setPrintRange"
            @input="checkPages"
          />
        </div>
        <div class="line-print">
          <span>{{ $t("bookPrint.copies") }}</span>
          <input ref="from" type="text" v-model="copies" class="a-center" />
        </div>
        <div
          class="line-print mrg-b-30 mrg-t-12"
          v-if="isElectron && showPrinters"
        >
          <div class="title mrg-b-9">{{ $t("bookPrint.printer") }}</div>
          <ComboboxInput
            :no_decoration="true"
            class="w-300 fit-height inline-flex"
            :items="printers"
            @input="setSelectedPrinter"
            :labal="selectedPrinter"
            :labelKey="selectedPrinter"
            :labelStart="selectedPrinterInx"
          />
          <button
            class="btn btn-outline"
            v-kiosk.remove
            v-if="printers.length"
            @click="setPrintDialog(0)"
          >
            ...
          </button>
        </div>

        <div class="note1" v-if="appMode.online()">
          {{ $t("bookPrint.note1") }}
        </div>
        <!--    <div
          class="flex-column rtl flex-align-center online-print-part"
          v-if="showPrintCodePart && !loading && !unlimitedPrints"
        >
          <div class="flex-column flex-align-center" v-if="!isUserIP">
            <span class=" allow-print-msg">
              {{
                (!unlimitedPerUsage
                  ? $t("bookPrint.allowedPrintsMsg")
                  : $t("bookPrint.allowedPrintsUnLimited")) +
                  " " +
                  userPrintInfo.allowedPrints
              }}
            </span>
            <div v-if="userPrintInfo.code">
              <div class="flex-column flex-align-center">
                <span>
                  {{ $t("bookPrint.printCodeMsg") + " " + userPrintInfo.code }}
                </span>
                <span class="yitra-txt">
                  {{ $t("bookPrint.pagesLeft") + " " + userPrintInfo.pages }}
                </span>
              </div>
              <div class="flex-row flex-align-center">
                <span style="padding-left:10px">
                  {{ $t("bookPrint.purchaseAnotherTicket") }}
                </span>
                <div class="btn btn-outline" @click="goToStore">
                  {{ $t("bookPrint.purchasePrintCode") }}
                </div>
              </div>
            </div>
            <div v-else class="flex-column flex-align-center">
              <span>
                {{ $t("bookPrint.usePrintCodeMsg") }}
              </span>
              <div class="flex-row flex-align-center">
                <span style="padding-left:10px"
                  >{{ $t("bookPrint.purchaseTicket") }}
                </span>
                <div class="btn btn-outline" @click="goToStore">
                  {{ $t("bookPrint.purchasePrintCode") }}
                </div>
              </div>
            </div>
          </div>

          <div v-else class="flex-column">
            <span class="allow-print-msg">
              {{
                $t("bookPrint.allowedPrintsMsg") +
                  " " +
                  userPrintInfo.allowedPrints
              }}
            </span>
            <div class="flex-column flex-align-center">
              <span class="bold gray-b-border">
                {{ $t("bookPrint.usePrintCodeMsg") }}
              </span>
              <div class="flex-column">
                <div
                  class="flex-row"
                  style="padding-top: 10px;width: 100%;padding-bottom: 5px"
                >
                  <baseInput
                    class="b-border full-w no-padd"
                    :placeholder="$t('bookPrint.inputPrintCode')"
                    @input="setPrintCode($event)"
                    :text="printCode"
                    @keydown.enter="getPagesLeft"
                  />
                  <div
                    style="margin-right:5px;height:25px"
                    class="btn btn-outline"
                    @click="getPagesLeft"
                  >
                    {{ $t("bookPrint.showPagesLeft") }}
                  </div>
                </div>
                <div
                  style="padding-top:5px"
                  class="flex-row rtl flex-align-center printcode-msg"
                  v-if="printCodePages != -1"
                >
                  {{ $t("bookPrint.printTicket") }} {{ printCode }},
                  <span> {{ $t("bookPrint.left") }} {{ printCodePages }} </span>
                </div>
                <div class="flex-row">
                  <span> {{ $t("general.or") }}:</span>
                  <div class="btn btn-outline" @click="goToStore">
                    {{ $t("bookPrint.purchasePrintCode") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="line-print mrg-b-12 mrg-t-12">
          <div class="title mrg-b-9">{{ $t("bookPrint.titleTopPage") }}</div>
          <baseInput
            v-if="!disableHeader"
            class="b-border full-w no-padd"
            :placeholder="$t('bookPrint.topTitlePlaceHolder')"
            @input="getHeader($event)"
            :text="header"
          />
          <div class="header-for-print" v-else>{{ header }}</div>
        </div>
        <div class="line-print">
          <div class="title">{{ $t("bookPrint.comment") }}</div>
          <div class="flex-row rtl flex-align-center mrg-r-6">
            <baseToggleSwitch
              @toggle="printComments($event.target.checked)"
              @click.self.stop
              :checked="wComments"
              class="left-icon"
            />
            <span>{{ $t("bookPrint.contentComment") }}</span>
          </div>
        </div>

        <div class="line-print">
          <div class="title">{{ $t("bookPrint.markers") }}</div>
          <div class="flex-row rtl flex-align-center mrg-r-6">
            <baseToggleSwitch
              @toggle="printMarkers($event.target.checked)"
              @click.self.stop
              :checked="wMarkers"
              class="left-icon"
            />
            <span>{{ $t("bookPrint.contentMarker") }}</span>
          </div>
        </div>

        <div
          class="flex-row small-file"
          v-if="false && appMode.offline() && !loading"
        >
          <baseCheckBox
            class="check-item check-larg"
            @change="setSmallFile"
            size="larg"
            :checked="exportSmallPDF"
          />
          <span>{{ $t("bookPrint.smallFile") }}</span>
        </div>
        <div v-if="appMode.online()" class="online-print-part">
          <div class="title" style="padding-bottom: 5px">
            {{ $t("bookPrint.printLic") }}
          </div>
          <div class="flex-column flex-align-center">
            <span class="allow-print-msg">{{ $t("bookPrint.noLimit") }}</span>
          </div>
          <div
            class="flex-column rtl flex-align-center p-t-5"
            v-if="showPrintCodePart && !loading && !unlimitedPrints"
          >
            <div class="flex-column flex-align-center" v-if="!isUserIP">
              <span class="allow-print-msg bold p-t-5">
                {{
                  !unlimitedPerUsage
                    ? userPrintInfo.code
                      ? ""
                      : $t("bookPrint.allowedMsg")
                    : $t("bookPrint.allowedPrintsUnLimited") +
                      " " +
                      userPrintInfo.allowedPrints
                }}
              </span>
              <span
                class="yitra-txt p-t-5"
                v-if="!unlimitedPerUsage && !userPrintInfo.code"
              >
                {{
                  $t("bookPrint.dailyCredit") +
                  userPrintInfo.allowedPrints +
                  $t("bookPrint.pages")
                }}
              </span>

              <div v-if="userPrintInfo.code">
                <div class="flex-column flex-align-center">
                  <span class="p-t-5 bold">
                    {{
                      $t("bookPrint.printCodeMsg") + " " + userPrintInfo.code
                    }}
                  </span>
                  <span class="yitra-txt p-t-5">
                    {{
                      $t("bookPrint.pagesLeft") +
                      " " +
                      userPrintInfo.pages +
                      " (+ " +
                      userPrintInfo.allowedPrints +
                      " " +
                      $t("bookPrint.dailyLic") +
                      ")"
                    }}
                  </span>
                </div>
                <div class="flex-row flex-align-center">
                  <span style="padding-left: 10px" class="p-t-5">
                    {{ $t("bookPrint.purchaseAnotherTicket") }}
                  </span>
                  <div class="btn btn-outline" @click="goToStore">
                    {{ $t("bookPrint.purchasePrintCode") }}
                  </div>
                </div>
              </div>
              <div v-else class="flex-column flex-align-center">
                <span class="p-t-5">
                  {{ $t("bookPrint.usePrintCodeMsg") }}
                </span>
                <div class="flex-row flex-align-center">
                  <span style="padding-left: 10px" class="p-t-5"
                    >{{ $t("bookPrint.purchaseTicket") }}
                  </span>
                  <div class="btn btn-outline" @click="goToStore">
                    {{ $t("bookPrint.purchasePrintCode") }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="flex-column">
              <span
                v-if="printCodePages == -1"
                class="allow-print-msg p-t-5 yitra-txt"
              >
                {{
                  $t("bookPrint.allowedPrintsMosad") +
                  " " +
                  userPrintInfo.allowedPrints
                }}
              </span>
              <div v-else class="flex-column flex-align-center">
                <span class="p-t-5 bold">
                  {{ $t("bookPrint.printCodeMsg") + " " + printCode }}
                </span>
                <span class="yitra-txt p-t-5">
                  {{
                    $t("bookPrint.pagesLeft") +
                    " " +
                    printCodePages +
                    " (+ " +
                    userPrintInfo.allowedPrints +
                    " " +
                    $t("bookPrint.dailyLic") +
                    ")"
                  }}
                </span>
              </div>

              <div class="flex-column flex-align-center">
                <span class="bold gray-b-border" p-t-5>
                  {{ $t("bookPrint.usePrintCodeMsg") }}
                </span>
                <div class="flex-column">
                  <div
                    class="flex-row"
                    style="padding-top: 10px; width: 100%; padding-bottom: 5px"
                  >
                    <baseInput
                      class="b-border full-w no-padd"
                      :placeholder="$t('bookPrint.inputPrintCode')"
                      @input="setPrintCode($event)"
                      :text="printCode"
                      @keydown.enter="getPagesLeft"
                    />
                    <div
                      style="margin-right: 5px; height: 25px"
                      class="btn btn-outline"
                      @click="getPagesLeft"
                    >
                      {{ $t("bookPrint.showPagesLeft") }}
                    </div>
                  </div>

                  <div class="flex-row p-t-5">
                    <span> {{ $t("general.or") }}:</span>
                    <div class="btn btn-outline" @click="goToStore">
                      {{ $t("bookPrint.purchasePrintCode") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex-column rtl"
            style="padding-top: 5px"
            v-if="printedPagesData"
          >
            <span class="allow-print-msg bold" style="text-align: right">{{
              $t("bookPrint.alreadyPrinted")
            }}</span>
            <div class="flex-column rtl flex-align-center">
              <p v-for="(p, i) in userPrintInfo.printedPages" :key="i">
                {{
                  p.fromPage == p.toPage
                    ? p.fromPage
                    : p.fromPage + " " + $t("bookPrint.untill") + " " + p.toPage
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-print">
        <div class="btn btn-outline" @click="closeWindow" v-if="!loading">
          {{ $t("bookPrint.cancel") }}
        </div>

        <div
          class="btn btn-outline"
          :class="{ disable: !allowedPDF }"
          @click="printPDF"
          v-show="showBtnPrintToPdf"
          v-if="!loading && kioskCheck"
        >
          {{ $t("general.exportPdf") }}
        </div>

        <div
          id="printToPrinterBtn"
          class="btn"
          :class="{ disable1: !allowedPrint }"
          @click="printToPrinter"
          v-if="!loading && allowPcPrint"
        >
          {{ $t("bookPrint.btnTxt") }}
        </div>

        <div class="btn btn-outline" @click="cancelPrint" v-if="loading">
          {{ $t("bookPrint.cancel") }}
        </div>
      </div>
      <div
        class="title mrg-b-9 a-center content-print content loading-print"
        v-if="loading"
      >
        <p>
          {{
            stage == 1
              ? $t("bookPrint.prepare")
              : stage == 2
              ? $t("bookPrint.export")
              : $t("bookPrint.downloading")
          }}
        </p>
        <p
          style="font-weight: 400"
          v-if="
            !onlyCurrent &&
            $store.state.progressWindow.currentPage != 0 &&
            stage < 3
          "
        >
          {{
            `${$store.state.progressWindow.currentPage} 
              ${$t("general.ofResults")} 
              ${$store.state.progressWindow.numPages}`
          }}
        </p>
      </div>
      <bounce-loader
        :loading="loading"
        :color="color"
        :size="size"
      ></bounce-loader>
    </div>
  </div>
</template>
<script>
import {
  printBook,
  stopPrinting,
  sendPrintSocket,
  getUserPrintInfo,
  getPrintCodeLeft,
} from "@/services/print.js";

import wasm_pdf_mgr from "@/services/bookData_WASM_pdf.js";
import BounceLoader from "vue-spinner/src/BounceLoader.vue";
import { mapGetters } from "vuex";
import { getBookName } from "@/services/bookData.js";
import { fetchBookByID } from "@/services/loadBooksDataFromServer.js";
import { printPreview } from "@/services/bookLists.js";
import { Axios } from "@/services/_axios";
import onlineHelper from "@/services/onlineStations";
import dataConfig from "@/config/database.js";

const allowed5Books = [
  147385, 147386, 147556, 147499, 147557, 147558, 147497, 147437, 146794,
  147496, 147508, 147466,
];

const machonShuaBooks = [
  "147760",
  "147758",
  "147759",
  "147776",
  "62726",
  "169725",
  "147777",
  "183348",
  "147778",
  "164149",
  "147781",
  "147779",
  "147761",
  "150966",
  "147780",
  "157098",
  "147762",
  "194617",
];
const onePagePrintBook = [
  51140, 168207, 83722, 688216, 688217, 688218, 194743, 638200, 156395, 156396,
  686314, 686334, 638201, 686191, 610022, 686185, 194744, 608770, 686315,
  637194, 686335, 686336, 686337, 686338, 686339, 686348, 51084, 686330, 686343,
  608772, 190744, 686332, 686333, 609248, 686199, 686200, 156417, 686203,
  686202, 51106, 687257, 687256, 85220, 686325, 51064, 51098, 51159, 51063,
  686327, 687259, 687258, 686997, 627229, 686999, 686996, 627230, 686992,
  686995, 686991, 686994, 686998, 687000, 629268, 687001, 686993, 51014, 168038,
  658414, 658415, 658416, 675813, 684087,
];

const maxPagesToPDF = 20;
const maxPagesMachonShua = 3;
const maxPagesOrLayesharim = 1;
const maxToOnline = 1;
export default {
  components: {
    BounceLoader,
  },
  props: ["pages", "show", "page", "book", "tabId", "drawFs", "from", "to"],
  data() {
    return {
      selectedPrinterInx: -1,
      selectedPrinter: 0,
      printers: [],
      fromPage: this.page,
      toPage: this.page,
      copies: 1,
      onlyCurrent: true,
      loading: false,
      color: "var(--custom-color1)",
      size: "50px",
      header: "",
      wComments: false,
      wMarkers: false,
      errorMessage: "",
      allowedPDF: true,
      allowedPrint: true,
      warnPopupsNotAllowed: false,
      userPrintInfo: {},
      printCode: "",
      printCodePages: -1,
      react: 0,
      stage: 1,
      bookName: "",
      printId: "",
      infoMessage: "",
      disableHeader: false,
    };
  },
  sockets: {
    creatingPdf: async function (data) {
      onlineHelper.startOnlineTimer();
      if (data.pages == data.current) {
        this.stage = 3;
      }
      this.$store.state.progressWindow.numPages = data.pages;
      this.$store.state.progressWindow.currentPage = data.current;
    },
    printBuffer: async function (data) {
      if (!data) {
        this.loading = false;
        this.$emit("loading", false);
        if (this.appMode.online()) this.errorMessage = "תקלה בהדפסה";
        this.$store.state.printing = {};
        return;
      }

      //check if need to do client rendering
      if (data.pdfBuffer == "client") {
        let imgs = [];
        this.$store.state.progressWindow.numPages =
          data.data.toPage - data.data.fromPage + 1;
        for (let i = data.data.fromPage; i <= data.data.toPage; i++) {
          let png = await wasm_pdf_mgr.getPdfPage(
            data.data.bookId,
            i,
            300,
            1
            // data.data.usePdfFile ? "19" : "21"
          );

          let picture = png.data;

          // match it to "swiz" type
          let sizes = Buffer.alloc(8);
          sizes.writeInt32LE(png.w);
          sizes.writeInt32LE(png.h, 4);

          let header = new Uint8Array(4);
          header[2] = 73;
          header[1] = 88;

          picture = new Uint8Array(12 + png.data.length);
          picture.set(header);
          picture.set(sizes, 4);
          picture.set(png.data, 12);

          let width = 3000;
          let height = parseInt((3000 / png.owidth) * png.oheight);

          let imageMetaData = {
            width,
            height,
            top: 0,
            crop: true,
          };
          imgs.push({ picture, imageMetaData });
          this.$store.state.progressWindow.currentPage = i - data.data.fromPage;
        }
        this.stage = 2;

        await printBook({
          bookId: data.data.bookId,
          fromPage: data.data.fromPage,
          toPage: data.data.toPage,
          pagesArr: this.pages,
          bookName: data.data.bookName,
          header: data.data.header,
          wComments: this.wComments,
          wMarkers: this.wMarkers,
          tabId: this.tabId,
          pdf: data.printMode == "PDF",
          drawFs: true,
          results: imgs,
          small: false,
          copies: 1,
        });
        this.loading = false;
        this.$emit("loading", false);
        this.closeWindow();
        this.$store.state.printing = {};
        return;
      }
      this.$store.state.printing = {};
      this.loading = false;
      this.$emit("loading", false);

      let pdfName =
        "אוצר החכמה_" +
        this.bookName +
        "_" +
        (this.fromPage === this.toPage
          ? this.fromPage
          : this.fromPage + "_" + this.toPage) +
        ".pdf";
      pdfName = pdfName.replace(/[/\\?%*:|"<>]/g, "-");

      let res = printPreview(
        //  dataConfig.Server +
        data.pdfBuffer,
        pdfName,
        data.printMode == "print",
        "URL",
        data.copies
      );

      if (res == "popupsNotAllowed") {
        this.warnPopupsNotAllowed = true;
      } else this.closeWindow();
    },
    finishedPrintBook: async function (data) {
      if (!data) {
        this.loading = false;
        this.$emit("loading", false);
        if (this.appMode.online())
          this.errorMessage = this.$t("bookPrint.printOverflow");
        return;
      }
      this.stage = 2;
      let res = await printBook({ ...data, small: this.exportSmallPDF });
      this.loading = false;
      this.$emit("loading", false);
      if (res == "popupsNotAllowed") {
        this.warnPopupsNotAllowed = true;
      } else {
        this.closeWindow();
      }
    },
    printingInfo: async function (data) {
      onlineHelper.startOnlineTimer();
      if (data.pages == data.current) {
        this.stage = 2;
      }
      this.$store.state.progressWindow.numPages = data.pages;
      this.$store.state.progressWindow.currentPage = data.current;
    },
    printId: function (data) {
      this.printId = data;
      this.$emit("printId", this.printId);
    },
  },
  computed: {
    ...mapGetters("books", ["getBookbyId"]),
    ...mapGetters("user", ["isUserIP"]),

    allowPcPrint() {
      return globalThis.OTZAR_BASIC_INFO.enablePrint;
    },
    kioskCheck() {
      if (!this.$store.state.kiosk) return true;
      else if (
        globalThis.OTZAR_BASIC_INFO.pdfAuthPath &&
        globalThis.OTZAR_BASIC_INFO.pdfAuthPath != ""
      ) {
        return true;
      }
      return false;
    },
    machonShuaBook() {
      return machonShuaBooks.includes(this.book);
    },
    allowed5Books() {
      return allowed5Books.includes(parseInt(this.book));
    },
    orLayesharimBookOrMYerushalmiOrOvadia() {
      //also if this is maero or yersuhalmi
      let myesuhalmi = [
        677158, 677157, 677156, 677155, 677154, 677153, 677148, 677147, 677146,
        677141, 677140, 677139, 677138, 677136, 677135, 677134, 677130, 677128,
        677127, 677124, 677123, 677120, 677119, 677118, 677022, 677021, 677020,
        677015, 677010, 677009, 677008, 677007, 677006, 677005, 677004, 677003,
        677002, 677001, 677000,
      ];
      if (myesuhalmi.includes(Number(this.book))) return true;
      if (onePagePrintBook.includes(Number(this.book))) return true;
      return (
        this.$store.getters[`tabs/${this.tabId}/yesharimBook`] ||
        this.$store.getters[`tabs/${this.tabId}/ovadiaBook`]
      );
    },
    showBtnPrintToPdf() {
      if (globalThis.OTZAR_BASIC_INFO.disableBtnPrintToPdf) return false;
      return true;
    },
    printedPagesData() {
      return (
        this.appMode.online() &&
        this.userPrintInfo?.printedPages &&
        this.userPrintInfo?.printedPages.length > 0
      );
    },
    showPrinters() {
      return false;
      return globalThis.OTZAR_BASIC_INFO.showPrinters;
    },
    unlimitedPrints() {
      return this.userPrintInfo.allowedPrints >= 1000000;
    },
    unlimitedPerUsage() {
      return this.userPrintInfo.printLimitedPerUsage == 0;
    },
    maxToPrintOnline() {
      let react = this.react;
      if (
        globalThis.DEV_CONNECT_USER_TO_FREE_AUTO &&
        this.$store.state.user.userType == "GUEST"
      )
        return maxToOnline;
      else {
        let allowedPages =
          (this.userPrintInfo.allowedPrints || 0) +
          (this.userPrintInfo.pages || 0);
        return allowedPages;
      }
    },
    exportSmallPDF() {
      return this.userSettings.settings.exportSmallPDF == 1;
    },
    showPrintCodePart() {
      return (
        this.appMode.online() && this.$store.state.user.userType != "GUEST"
      ); // !globalThis.DEV_CONNECT_USER_TO_FREE_AUTO;
    },
    maxToPDF() {
      return globalThis.SERVER_MODE == "offline"
        ? this.machonShuaBook
          ? maxPagesMachonShua
          : this.orLayesharimBookOrMYerushalmiOrOvadia
          ? maxPagesOrLayesharim
          : this.allowed5Books
          ? 5
          : maxPagesToPDF
        : this.maxToPrintOnline;
    },
    maxToPrint() {
      return globalThis.SERVER_MODE == "offline"
        ? this.machonShuaBook
          ? maxPagesMachonShua
          : this.orLayesharimBookOrMYerushalmiOrOvadia
          ? maxPagesOrLayesharim
          : this.allowed5Books
          ? 5
          : 1000000
        : this.maxToPrintOnline;
    },
    /*   allowedPrint() {
      if (globalThis.SERVER_MODE == "offline") return true;
      if (
        globalThis.SERVER_MODE == "online" &&
        this.toPage - this.fromPage >= this.maxToPrintOnline &&
        !this.onlyCurrent
      ) {
        return false;
      }
      return true;
    }, */
    initHeader() {
      return (
        this.header || this.userSettings.settings.userConfig?.printHeader || ""
      );
    },
    getFromPage() {
      return this.page;
    },
    isElectron() {
      return globalThis.ELECTRON_ENV;
    },
  },
  methods: {
    setPrinterObject() {
      globalThis.SEND_PRINT_JOB(JSON.stringify(this.printerOptions));
    },
    setSmallFile() {
      if (this.userSettings.settings.exportSmallPDF == 1)
        this.userSettings.setSettings("exportSmallPDF", "0");
      else this.userSettings.setSettings("exportSmallPDF", "1");
    },
    printComments(check) {
      this.wComments = check;
    },
    printMarkers(check) {
      this.wMarkers = check;
    },
    getHeader($event) {
      this.header = $event.target.value;
    },
    setPrintCode($event) {
      this.printCodePages = -1;
      this.printCode = $event.target.value;
    },
    getPagesLeft() {
      let _this = this;
      //get pages left of print code
      if (!this.printCode) return;
      getUserPrintInfo(this.book, this.printCode || -1).then((data) => {
        this.userPrintInfo = data;

        getPrintCodeLeft(this.printCode).then((data) => {
          _this.printCodePages = data.pages;
          _this.userPrintInfo.pages = data.pages;
          _this.react++;
          _this.checkPages();
        });
      });
    },
    goToStore() {
      window.open(this.$t("mainMenu.otzarStoreURL"));
    },
    closeWindow() {
      this.$emit("print", { show: false });
      //this.togglePrintBookVisible();
    },
    inputFrom(event) {
      let from = parseInt(event.target.value);
      if (!from) return;
      if (!isNaN(from)) this.fromPage = from;
      else alert("enter a number");
    },
    inputTo(event) {
      let to = parseInt(event.target.value);
      if (!to) return;
      if (!isNaN(to)) this.toPage = to;
      else alert("enter a number");
    },
    validateNumber() {},
    cancelPrint() {
      this.loading = false;
      this.$emit("loading", false);
      stopPrinting();
      this.$emit("close");
      this.$socket.client.emit("printCancel", this.printId);
    },
    async getBookFromServer(bookId) {
      let bookDetails = await fetchBookByID(bookId);

      if (bookDetails) {
        return {
          bookId: bookDetails.id,
          ...bookDetails,
          mainAuthorName:
            bookDetails.authors.length > 0 ? bookDetails.authors[0].name : "",
        };
      } else return false;
    },
    async printToPrinter() {
      globalThis._printer = this.selectedPrinter;
      globalThis._printCopies = this.copies;
      this.stage = 1;
      if (!this.allowedPrint) return;
      this.checkPages();
      this.warnPopupsNotAllowed = false;
      const bookOnlyMode = this.$store.state.bookOnlyMode;
      this.errorMessage = "";
      let book = this.book;
      try {
        this.fromPage = Number(this.fromPage);
        this.toPage = Number(this.toPage);
        let fPage = this.fromPage;
        let tPage = this.toPage;
        if (this.onlyCurrent) {
          fPage = this.page;
          tPage = this.page;
        } else {
          fPage = this.fromPage;
          tPage = this.toPage;
        }

        if (fPage > this.pages.length) fPage = this.pages.length;
        if (tPage > this.pages.length) tPage = this.pages.length;

        let bookb = null;
        if (bookOnlyMode) {
          bookb = await this.getBookFromServer(book);
        } else bookb = this.getBookbyId(book);
        if (!bookb) return;
        let Name = getBookName(bookb.name, bookb.volume, true);
        let author = bookb.mainAuthorName;
        if (author != "") Name += " / " + author;
        this.bookName = Name;
        this.loading = true;
        this.$emit("loading", true);
        this.$store.state.print.show = this.$store.state.print.show + 1;

        try {
          this.copies = parseInt(this.copies);
        } catch {
          this.copies = 1;
        }
        let printingData = {
          bookId: book,
          fromPage: fPage,
          toPage: tPage,
          pagesArr: this.pages,
          bookName: Name,
          header: this.header,
          wComments: this.wComments,
          wMarkers: this.wMarkers,
          tabId: this.tabId,
          pdf: false,
          socket: this.$socket.client,
          drawFs: this.drawFs,
          printCode: this.printCode,
          copies: this.copies,
        };
        this.$store.state.printing = printingData;
        await sendPrintSocket(printingData);
      } catch (ex) {
        this.$store.state.printing = {};
        this.errorMessage = this.$t("bookPrint.errorPrinting") + ex.message;
        console.log("error in printing >> " + ex.message);
      }
    },

    checkPages() {
      //offline
      if (globalThis.SERVER_MODE == "offline") {
        const pagesToPrint = this.onlyCurrent
          ? 1
          : Math.abs(this.toPage - this.fromPage) + 1;
        //PDF
        if (pagesToPrint > this.maxToPDF) {
          this.allowedPDF = false;
        } else {
          this.allowedPDF = true;
          this.errorMessage = "";
        }

        //print
        if (pagesToPrint > this.maxToPrint) {
          this.allowedPrint = false;
        } else {
          this.allowedPrint = true;
          this.errorMessage = "";
        }
      }

      //online
      if (globalThis.SERVER_MODE == "online") {
        let allowedRanges = this.userPrintInfo?.printedPages;
        if (allowedRanges && allowedRanges[0]) {
          let pagesRangeAllowed = false;
          for (i in allowedRanges) {
            let p = allowedRanges[i];
            if (this.fromPage >= p.fromPage && this.toPage <= p.toPage) {
              pagesRangeAllowed = true;
              break;
            }
          }
          if (pagesRangeAllowed) {
            this.errorMessage = "";
            this.allowedPDF = true;
            this.allowedPrint = true;
            return;
          }
        }
        if (
          (!this.onlyCurrent &&
            (this.toPage - this.fromPage >= this.maxToPrintOnline ||
              (this.machonShuaBook &&
                this.toPage - this.fromPage >= maxPagesMachonShua))) ||
          (this.orLayesharimBookOrMYerushalmiOrOvadia &&
            this.toPage - this.fromPage >= maxPagesOrLayesharim) ||
          (this.allowed5Books && this.toPage - this.fromPage >= 5)
        ) {
          this.allowedPDF = false;
          this.allowedPrint = false;
          if (
            !this.machonShuaBook &&
            !this.orLayesharimBookOrMYerushalmiOrOvadia &&
            this.allowed5Books
          )
            this.errorMessage = this.$t("bookPrint.maxToOnline").replace(
              "%NUM%",
              this.maxToPrintOnline
            );
        } else {
          this.errorMessage = "";
          this.allowedPDF = true;
          this.allowedPrint = true;
        }
      }
    },
    setSelectedPrinter(e) {
      // this.setPrintDialog(1);
      this.selectedPrinter = e.key;
    },
    setPrintDialog(mode = 0) {
      let printer = this.selectedPrinter;
      if (!printer) {
        const item = this.printers.find((element) => element.isDefault);
        if (item) printer = item.key;
      }
      if (!printer) return;
      Axios.post("/api/general/p-dialog", {
        name: printer,
        mode,
      });
    },
    async printPDF() {
      this.stage = 1;
      if (!this.allowedPDF) return;
      const bookOnlyMode = this.$store.state.bookOnlyMode;
      this.errorMessage = "";
      let book = this.book;
      try {
        this.fromPage = Number(this.fromPage);
        this.toPage = Number(this.toPage);
        let fPage = this.fromPage;
        let tPage = this.toPage;
        if (this.onlyCurrent) {
          fPage = this.page;
          tPage = this.page;
        } else {
          fPage = this.fromPage;
          tPage = this.toPage;
        }

        if (fPage > this.pages.length) fPage = this.pages.length;
        if (tPage > this.pages.length) tPage = this.pages.length;

        let bookb = null;
        if (bookOnlyMode) {
          bookb = await this.getBookFromServer(book);
        } else bookb = this.getBookbyId(book);
        if (!bookb) return;
        if (
          this.appMode.offline() &&
          Math.abs(tPage - fPage) >= this.maxToPDF
        ) {
          this.errorMessage = this.$t("bookPrint.PDFLimited").replace(
            "%NUM%",
            this.maxToPDF
          );
          return;
        }
        let Name = getBookName(bookb.name, bookb.volume, true);
        let author = bookb.mainAuthorName;
        if (author != "") Name += " / " + author;
        this.loading = true;
        this.$emit("loading", true);

        let printingData = {
          bookId: book,
          fromPage: fPage,
          toPage: tPage,
          pagesArr: this.pages,
          bookName: Name,
          header: this.header,
          wComments: this.wComments,
          wMarkers: this.wMarkers,
          tabId: this.tabId,
          pdf: true,
          socket: this.$socket.client,
          drawFs: this.drawFs,
          printCode: this.printCode,
          copies: 1,
        };

        /*   debugger;
        const printerClass = require("@/services/printService.js").PrintService;
        let printer = new printerClass(this.$socket.client);
        printer.printToPDFOnline(printingData);
        return; */
        this.$store.state.printing = printingData;
        await sendPrintSocket(printingData);
      } catch (ex) {
        this.errorMessage = this.$t("bookPrint.errorPrinting") + ex.message;
        console.log("error in printing >> " + ex.message);
      }
    },
    choosePrintOnlyCurrent(e) {
      if (e.target.checked) this.allowedPDF = true;
      this.onlyCurrent = e.target.checked;
      this.checkPages();
    },
    choosePrintRange(e) {
      this.onlyCurrent = !e.target.checked;
      if (e.target.checked) this.checkPages();
    },
    setPrintRange() {
      this.onlyCurrent = false;
    },
    loadPrinters() {
      if (globalThis.ELECTRON_ENV) {
        const printers = JSON.parse(globalThis.GET_PRINTERS());
        this.printers = printers.map((a) => {
          a.label = a.displayName;
          a.key = a.name;
          return a;
        });

        //we can do it in map but for good coding we do it here (seperatly)
        let i = 0;
        let e = null;
        for (const element of this.printers) {
          if (element.isDefault) {
            e = element;
            break;
          }
          i++;
        }

        if (!e && this.printers.length) {
          e = this.printers[0];
          i = 0;
        }

        if (e) {
          this.selectedPrinter = e.key;
          this.selectedPrinterInx = i;
        }

        // const item = this.printers.find((element) => element.isDefault);
        // if (item) {
        //   this.selectedPrinter = item.key;
        // }
      }
    },
  },

  async mounted() {
    const bookOnlyMode = this.$store.state.bookOnlyMode;
    if (bookOnlyMode) {
      this.bookDetails = await this.getBookFromServer(this.book);
    } else this.bookDetails = this.getBookbyId(this.book);
    if (this.machonShuaBook)
      this.infoMessage = this.$t("bookPrint.limitMsg").replace(
        "%1%",
        maxPagesMachonShua
      );

    if (this.orLayesharimBookOrMYerushalmiOrOvadia)
      this.infoMessage = this.$t("bookPrint.limitMsg").replace(
        "%1%",
        maxPagesOrLayesharim
      );

    if (this.allowed5Books)
      this.infoMessage = this.$t("bookPrint.limitMsg").replace("%1%", "5");

    this.loadPrinters();

    // const item = this.printers.find((element) => element.isDefault);
    // if (item) {
    //   this.selectedPrinter = item.key;
    //   //prefomance :-(
    //   this.selectedPrinterInx = this.printers.findIndex(
    //     (element) => element.isDefault
    //   );
    // }
    this.allowedPDF = true;

    this.errorMessage = "";

    if (this.from > 0 && this.to > 0) {
      this.fromPage = this.from;
      this.toPage = this.to;
      this.checkPages();
      this.onlyCurrent = false;
    } else {
      this.fromPage = this.page;
      this.toPage = this.page;
    }

    if (this.userSettings.settings.userConfig?.printHeader)
      this.disableHeader = true;
    this.header = this.userSettings.settings.userConfig?.printHeader;

    //get print info of user for online only
    if (this.appMode.online()) {
      getUserPrintInfo(this.book, this.printCode || -1).then((data) => {
        this.userPrintInfo = data;
      });
    }
  },
};
</script>
<style lang="scss">
$bg-color2: #f7f7f7;
$bg-color5: #f4f4f4;
.main-container-print {
  height: calc(100% - 41px);
  width: 100%;
  overflow: auto;
}
.bold {
  font-weight: 600;
}
.printcode-msg {
  color: var(--custom-color2);
  font-weight: 600;
}
.allow-print-msg {
  text-align: center;
  padding-right: 10px;
  padding-left: 10px;
}
.gray-b-border {
  border-bottom: #dedede solid 1px;
}

.yitra-txt {
  color: var(--custom-color2);
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
}
.online-print-part {
  width: 100%;
  padding: 10px;
  margin-top: 20px;
  //background-color: $bg-color5;
  border: #dedede solid 1px;
}
.small-file {
  padding-right: 10px;
  width: 100%;
}
.title {
  font-size: 12px;
  font-weight: bold;
  // margin-bottom: 10px;
}
.full-w input {
  width: 100% !important;
}
.print-book {
  z-index: 9999 !important;
}
.print-book-container {
  // .header {
  //   width: 100%;
  //   height: 18px;
  //   line-height: 18px;
  //   position: relative;
  //   padding: 0 9px;
  //   color: #b2b2b2;
  //   font-weight: bold;
  //   margin-bottom: 15px;
  //   // background-color: #f1f1f1;
  // }
  // .header span {
  //   // padding-top: 20px;
  //   // padding-right: 20px;
  //   font-size: 12px;
  // }
}

.icon-del {
  // height: 6px;
  // position: absolute;
  // top: 0;
  // left: 8px;
  // width: 6px;
  svg {
    height: 6px;
    stroke: rgba($color: #000000, $alpha: 0.3);
    width: 6px;
  }
}
.btn-print {
  display: flex;
  justify-content: center;
  background-color: $bg-color5;
  padding: 8px 0;
  height: 41px;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.print-book-container .title {
  // padding: 0 25.5px;
  color: #b2b2b2;
  font-weight: 600;
  margin-top: 20px;
}
.line-print {
  margin-top: 40px;
}

.content-print {
  padding: 20px 15px 0 15px;
  input {
    padding: 0;
  }
  .line-print {
    margin: 0;
    margin-bottom: 3px;
    align-items: center;
    .check-larg label {
      top: 0;
      transform: translate(0);
    }
  }
}
.line-print input {
  width: 31px;
  height: 15px;
  // text-align: center;
  // background: $bg-color2;
  border: 1px solid #dedede;
  margin: 0 3px;
  border: 0;
  border-bottom: 1px solid #b2b2b2;
  border-radius: 0;
  line-height: 20.5;
  height: 20.5px;
  font-size: 12px;
  &::placeholder {
    line-height: 20.5;
    height: 20.5px !important;
    font-size: 12px !important;
    color: #b2b2b2 !important;
  }
  &:focus {
    border: 0;
    border-bottom: 1px solid #b1b1b1;
  }
}
.note1 {
  font-size: 11px;
  color: #b2b2b2;
  margin: 10px 0 30px 0;
}
.inline-flex {
  display: inline-flex !important;
}
.note2 {
  color: #b1b1b1;
  font-size: 12px;
}
.icon-print-win {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  svg {
    fill: var(--custom-color1);
    stroke: var(--custom-color1);
    color: var(--custom-color1);
  }
}
.w-300 {
  width: 300px !important;
}
.line-print {
  .switch {
    margin: 7px 0 0 5px;
  }
}
.disable1 {
  background-color: var(--custom-color1) !important;
  opacity: 0.3;
}
.p-t-5 {
  padding-top: 5px;
}
.header-for-print {
  border: 1px solid #e5e5e5;
  border-radius: 15px;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  outline: 0;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
}
</style>
